// DOM content loaded event listener
document.addEventListener("DOMContentLoaded", function () {
  Fancybox.bind("[data-prodgallerybox]", {
    zoomEffect: true,
  });

  const gallerySwipper = new Swiper(".swiper", {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 50,
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        spaceBetween: 16,
      },
      1280: {
        spaceBetween: 80,
      },
      1560: {
        spaceBetween: 217,
      },
    },
  });
});
